import { FC } from "react";
import { PaxCheckQuestionSampleImage } from "api";

/* components */
import LocalImages from "assets/images/local-images";
import Content, { ContentNS } from "content/content";
import { SampleDocument } from "../have-document-questions/HaveDocumentQuestionsPane";

/* styles */
import QuestionSampleRoot from "./styles/QuestionSampleRoot.styled";
import Toggle from "./styles/Toggle.styled";
import { ButtonTitle } from "features/shared/styles/typography/ButtonTitle.styled";
import SampleCloseButton from "./styles/SampleCloseButton.styled";
import ButtonText from "features/shared/components/buttons/submit-button/styles/ButtonText.styled";

interface DocSampleDoxProps {
  sampleDocument: SampleDocument;
  onClose: () => void;
}

export const DocSampleBox: FC<DocSampleDoxProps> = ({
  sampleDocument,
  onClose,
}) => {
  if (!sampleDocument.image) return null;

  // Title-specific: always used for image alt text, so screen-reader users
  // can tell which document the sample depicts.
  const altTitle = Content.shared.t("question.sample", {
    title: sampleDocument.image.title,
    ns: ContentNS.checklist,
  });
  // Visible label: clients can override this to something generic (falls
  // back to altTitle when they don't).
  const visibleLabel = Content.shared.t("question.sample-label", {
    title: sampleDocument.image.title,
    ns: ContentNS.checklist,
    defaultValue: altTitle,
  });

  return (
    <section>
      <div className="doc-sample-header">
        <ButtonTitle>{visibleLabel}</ButtonTitle>
        <SampleCloseButton onClick={onClose}>
          <img
            className="sample-doc"
            src={LocalImages.shared.images.icons.burgerMenuClose}
            alt={altTitle}
          />
        </SampleCloseButton>
      </div>
      <img
        className="sample-doc"
        src={sampleDocument.image.url}
        alt={altTitle}
      />
    </section>
  );
};

interface QuestionSampleHaveDocumentsProps {
  isToggleOpen: boolean;
  onToggle: () => void;
  sampleImage: PaxCheckQuestionSampleImage;
}

export const QuestionSampleHaveDocuments: FC<
  QuestionSampleHaveDocumentsProps
> = ({ sampleImage, onToggle, isToggleOpen }) => {
  const visibleLabel = Content.shared.t("question.sample-label", {
    title: sampleImage.title,
    ns: ContentNS.checklist,
    defaultValue: Content.shared.t("question.sample", {
      title: sampleImage.title,
      ns: ContentNS.checklist,
    }),
  });

  return (
    <QuestionSampleRoot toggleOpen={isToggleOpen}>
      <Toggle onClick={onToggle}>
        <ButtonText>{visibleLabel}</ButtonText>
        <img
          className="toggle"
          src={LocalImages.shared.images.icons.docSampleToggle}
          alt="chevron icon"
        />
      </Toggle>
    </QuestionSampleRoot>
  );
};

export default QuestionSampleHaveDocuments;
